import { useContext } from 'react';

import ProductsContext from './ProductsContext';

const useProducts = () => {
  return useContext(ProductsContext);
};

export default useProducts;
